import { Button } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import {
  ButtonResponsiveProps,
  getResponsiveButtonProps,
} from './getResponsiveButtonProps';

// const ButtonTextWrapper = styled.span`
//   * + * {
//     margin-left: 8px;
//   }
// `;

// export interface ButtonResponsiveProps extends ButtonProps {
//   text?: React.ReactNode;
//   iconRight?: React.ReactNode;
// }

/**
 * Pulsante con modalità responsive
 * per eliminare il testo e lasciare solo l'icona in caso di spazi ridotti
 *
 * Se viene passata l'icona destra questa sarà sempre visibile
 */

export function ButtonResponsive(props: ButtonResponsiveProps) {
  const isMobile = useBreakpoint(down('md'));

  const buttonResponsiveProps = useMemo(() => {
    return getResponsiveButtonProps(props, isMobile);
  }, [props, isMobile]);

  return <Button {...buttonResponsiveProps} />;
}
